// TODO: the config should be passed as a variable
import config from '../../config'

function identity(input) {
  return input
}

function getURLParams(...args) {
  let id
  let opts = {}
  let i = 0

  if (args && args.length) {

    if (!args[i] || typeof args[i] !== 'object') {
      id = args[i]
      i += 1
    }

    opts = args[i] || {}

  }

  if (id && !opts.id) {
    opts.id = id
  }

  return opts
}

function formatUrl(path, apiVersion = null) {

  const hasApiVersions = config.apiVersions

  const adjustedPath = path[0] !== '/'
    ? `/${path}`
    : path

  let port = apiVersion
    ? (hasApiVersions && config.apiVersions[apiVersion].apiPort || config.apiPort)
    : config.apiPort

  port = (port && port * 1 !== 80)
    ? `:${port}`
    : ''

  const basePath = apiVersion
    ? (hasApiVersions && config.apiVersions[apiVersion].apiBasePath || config.apiBasePath)
    : config.apiBasePath

  const apiScheme = (apiVersion
    ? (hasApiVersions && config.apiVersions[apiVersion].apiScheme || config.apiScheme)
    : config.apiScheme) || ''

  const apiHost = apiVersion
    ? (hasApiVersions && config.apiVersions[apiVersion].apiHost || config.apiHost)
    : config.apiHost

  // Prepend host and port of the API server to the path.
  return `${apiScheme}//${
    apiHost + port
  }/${(basePath + adjustedPath).replace('//', '/')}`
    .replace(/\/$/, '')

  // Prepend `/api` to relative URL, to proxy to API server.
  // return `/api${adjustedPath}`

}

export class APIError extends Error { }

class SyncResult {
  constructor(API) {
    this.api = API
    this.newItems = []
    this.models = []
  }

  parse(id, opts, resultBody, origModel = null) {

    let collection = resultBody

    if (collection.collection) {
      collection = collection.collection
    }

    id = resultBody.id || id

    if (id || !collection) {
      resultBody.isComplete = true
      if (id) {
        resultBody.id = id
      }
      collection = [resultBody]
    }

    this.collection = collection

    const result = (this.api.store.afterLoad || [identity])
      .reduce((memo, method) => method(memo), {
        id, opts, collection,
      })

    this.resultBody = resultBody
    this.error = resultBody.error

    this.id = result.id
    this.opts = result.opts
    this.collection = result.collection
    this.origModel = origModel

    return this
  }

  apply(opts = {}) {

    if (this.error) {
      return this.getErrorResult()
    }

    if (opts.reset) {
      this.api.store.clear(opts)
    }

    if (Array.isArray(this.collection)) {
      (this.collection || []).forEach((item) => this.handleItem(item, opts))
    }

    if (this.newItems.length) {
      this.api.store.add(this.newItems, opts)
    }

    return this.getResult()

  }

  getResult() {

    const model = this.models.length === 1
      ? this.models[0]
      : {}

    return {
      id: model.id,
      opts: this.opts,
      body: this.resultBody,
      models: this.models,
    }
  }

  getErrorResult() {
    // eslint-disable-next-line max-len
    console.error(`An error occured while performing method ${this.opts.method} for ${this.api.store.Model.name}: `, this.error)

    return {
      id: null,
      models: null,
      error: this.error,
      body: this.resultBody,
      opts: this.opts,
    }
  }

  handleItem(item, opts = {}) {

    // TODO: this check alone is probably a bit dangerous
    if (!Number.isNaN(item.id * 1)) {
      item.id *= 1
    }

    const modelFromCollection = this.api.store.getById(item.id, opts)

    let model = this.origModel || modelFromCollection
    const isModelInCollection = this.api.store.contains(model, opts)

    // (item.id >= 0 && isModelInCollection)
    //   ? modelFromCollection
    //   : this.origModel

    // if there is a model, update it
    if (model) {
      model.set(item, {
        ...opts,
        synced: true
      })
      item = model
    }

    model = this.ensureItemModel(item, {
      ...opts,
      synced: true
    })

    if (opts.parseModel) {
      opts.parseModel(model)
    }

    if (!isModelInCollection) {
      this.newItems.push(model)
    }

    this.models.push(model)

  }

  ensureItemModel(item, opts = {}) {
    return item instanceof this.api.store.Model
      ? item
      : this.api.store.createModel(item, opts)
  }

}

const PARAM_REGEXP = /:([^/:]+)/g

export default class API {

  constructor(store, client, opts, middlewares = []) {

    this.validate(store, client, opts)

    this.store = store

    this.client = client

    this.middlewares = middlewares

    if (typeof opts.api === 'string') {
      opts.api = {
        url: opts.api,
        version: null,
      }
    }

    this.api = opts.api

  }

  validate(store, client, opts) {

    if (!store) {
      throw new APIError(`${this.constructor.name}: Each APIStore needs
        a 'store'`)
    }

    if (!client) {
      throw new APIError(`${this.constructor.name}: Each APIStore needs
        a 'client'`)
    }

    if (!opts.api) {
      throw new APIError(`${this.constructor.name}: Each APIStore needs
        an 'api' property defining the url of the ressource.`)
    }

  }

  createRequest(method) {

    return (url, params, opts = {}) => {
      if (opts.contentType) {
        params.contentType = opts.contentType
      }
      const promise = this.client[method](
        url,
        params,
        this.middlewares
      )

      let retval = promise

      const proxy = {
        then: (resolve, reject) => {
          retval = retval.then(resolve, reject)
          return proxy
        },
        catch: (resolve) => {
          retval = retval.catch(resolve)
          return proxy
        },
        request: promise.request,
      }

      return proxy
    }

  }

  save(id = null, data = {}, opts = {}) {

    // if (!opts.url && !id) {
    //   throw new APIError(`${this.constructor.name}: save expects an 'id'
    //     argument!`)
    // }

    opts.action = opts.action || 'save'

    const model = this.getModelForSave(data)
    const reqData = this.getDataForSave(data)
    const url = this.getURL(id, opts)
    const method = this.getMethodForSave(id, opts)
    const params = this.getParamsForSave(reqData, opts)

    return this.createRequest(method)(url, params, opts)
      .then((body) => {
        id = body.id
        return body
      })
      .then((body) => this.handleSyncResult(id, opts, body, model))

  }

  /**
   * @private
   */
  getParamsForSave(data, opts) {
    return {
      data,
      params: opts.params,
    }
  }

  /**
   * @private
   */
  getMethodForSave(id, opts = {}) {
    if (opts.method) {
      return opts.method
    }
    return id ? 'put' : 'post'
  }

  /**
   * @private
   */
  getModelForSave(data) {
    return data.getJSON ? data : null
  }

  /**
   * @private
   */
  getDataForSave(data) {

    if (data.getJSON) {
      data = data.getJSON()
    }

    data = data || this.store.asJSON()

    return data
  }

  /**
   * @param {String|Number} id?: The Id of the element to be loaded.
   * May be undefined or null to load the complete List
   * @param {Object} opts
   * @param {Object} data
   */
  load(id = undefined, opts = {}, data = null) {

    if (Object.prototype.toString.call(id) === '[object Object]') {
      data = opts
      opts = id
      id = undefined
    }

    const reqData = data || this.store.asJSON()

    this.loadingList = this.loadingList || {}

    if (id) {
      this.store.getById(id)
    }

    // ignore the filter params when creating the
    // abortable request
    // const { params, ...keyOpts } = opts
    // // eslint-disable-next-line no-unused-vars
    // const { filter, ...filterFreeParams } = params
    // keyOpts.filter = filterFreeParams

    const key = `${
      id || 'all'
    }:${JSON.stringify(opts)}`

    this.loadingList[key] = { opts }

    if (this.loadingList[key] && this.loadingList[key].loadingRequest) {
      console.log(`Already loading ${key}, skipping...`)
      return this.loadingList[key].loadingRequest
    }

    if (!opts.silent) {
      this.store.loading = true
    }

    // const result = (this.beforeLoad || [])
    //   .reduce((memo, method) => method(memo), { id, opts, data })
    //
    // id = result.id
    // opts = result.opts
    // data = result.data

    opts.action = opts.action || 'load'

    // requests a set of articles (items) based on page * limit for which block to return
    this.loadingList[key] = this.createRequest('get')(
      this.getURL(id, opts),
      {
        ...opts,
        data: reqData,
      }
    )
      .then((body) => {

        if (!id) {
          this.didCompleteLoad = true
        }

        delete this.loadingList[key]

        const retval = this.handleSyncResult(id, opts, body, null)

        this.store.loading = false

        return retval

      })
      .catch((err) => {

        delete this.loadingList[key]

        this.store.loading = false

        throw err

      })

    return this.loadingList[key]

  }

  getActionMethod(action) {

    if (!(action in this.api.actions)) {
      console.warn(`Action \`${action}\` not found for store ${this.store.constructor.name}`)
      return null
    }

    return this.api.actions[action]

  }

  handleSyncResult(id, opts, body, existingModel = null) {

    if (opts.handleResult) {
      return opts.handleResult(id, opts, body, existingModel)
    }

    return (new SyncResult(this))
      .parse(id, opts, body, existingModel)
      .apply(opts)

  }

  destroy(id = null, opts = {}) {

    // in case the model is passed in instead of just the id
    if (id.id) {
      id = id.id
    }

    if (!id) {
      throw new APIError(`${this.constructor.name}: destroy expects an
        'id' argument!`)
    }

    const deletedModel = this.store.getById(id)

    let index

    if (deletedModel) {
      index = this.store.collection.indexOf(deletedModel)

      this.store.collection.splice(index, 1)
    }

    opts.action = opts.action || 'delete'

    return this.createRequest('del')(
      this.getURL(id, opts),
      opts
    )
      .catch((ex) => {
        if (index) {
          this.store.collection.splice(index, 0, deletedModel)
        }
        throw ex
      })

  }

  /**
   * @private
   */
  isSpecialAction(action) {
    switch (action) {
      case undefined:
      case 'load':
      case 'save':
      case 'delete':
        return false
      default:
        return true
    }
  }

  getURL(...args) {

    const opts = getURLParams(...args)

    let url = this.getRoute(...args)

    if (!opts.noFormatUrl) {
      url = formatUrl(url, this.api.version)
    }

    return url

  }

  hasActionMethod(action) {
    return this.api.actions && action in this.api.actions
  }

  getRoute(...args) {

    const opts = getURLParams(...args)

    let url = (opts.url || this.api.url)

    if (this.isSpecialAction(opts.action) && this.hasActionMethod(opts.action)) {
      url = this.getActionMethod(opts.action)
    }

    // replace url params
    return url.replace(PARAM_REGEXP, (match, group1) => {

      if (!(group1 in opts)) {
        console.warn(`The url param :${group1} is not defined in the opts object`)
        return ''
      }

      return opts[group1]

    })
      // remove double slashes
      .replace('//', '/')

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/api.js